import { useIntl } from "@hlcr/ui/Intl";
import { TableCell, TableHead } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import React from "react";

const ReportBugsTableHead = () => {
	const intl = useIntl();
	return (
		<TableHead>
			<TableRow>
				<TableCell key={"title"}>
					{intl.fm("bugBounty.foundBugsTable.title")}
				</TableCell>
				<TableCell key={"programName"}>
					{intl.fm("bugBounty.foundBugsTable.program")}
				</TableCell>
				<TableCell key={"state"}>
					{intl.fm("bugBounty.foundBugsTable.status")}
				</TableCell>
				<TableCell key={"cvss"}>
					{intl.fm("bugBounty.foundBugsTable.cvss")}
				</TableCell>
				<TableCell key={"bounty"}>
					{intl.fm("bugBounty.foundBugsTable.bounty")}
				</TableCell>
				<TableCell key={"updatedAt"}>
					{intl.fm("bugBounty.foundBugsTable.lastUpdated")}
				</TableCell>
				<TableCell key={"actions"}>
					{intl.fm("user.inbox.header.actions")}
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default ReportBugsTableHead;
